<div class="customers-page">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <h2>Customers</h2>
    </div>
    <div class="header-actions">
      <button
        kendoButton
        themeColor="primary"
        [svgIcon]="plusIcon"
        (click)="onAddCustomer()"
      >
        Add Customer
      </button>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="stats-section">
    <!-- TODO: breakout each stat into its own component -->
    <div class="placeholder-stats">
      <div class="stat-card">
        <h3>Active Customers</h3>
        <p>32</p>
      </div>
      <div class="stat-card">
        <!-- TODO: Replace with existing New Customerscomponent from msp-portal/analytics -->
        <h3>New Customers (30 days)</h3>
        <p>7</p>
      </div>
      <div class="stat-card">
        <h3>Off-Boarded Customers (30 days)</h3>
        <p>3</p>
      </div>
    </div>
  </div>

  <!-- Content Section -->
  <div class="content-section">
    <!-- Loading State -->
    @if (isLoading()) {
    <div class="loading-container">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>Loading customers...</p>
      </div>
    </div>
    }

    <!-- Organizations Grid -->
    @if (!isLoading() && !error()) {
    <div class="grid-container">
      <div class="grid-instructions mb-3">
        <div
          class="alert"
          role="alert"
        >
          <div class="d-flex align-items-center">
            <span>Click on any customer row to view their service details.</span>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-end gap-3 mb-3">
        <div class="d-flex flex-column">
          <label
            class="form-label small text-muted mb-1"
            for="msp_customers_filter_status"
          >
            Status
          </label>
          <kendo-dropdownlist
            id="msp_customers_filter_status"
            [defaultItem]="{ text: 'All', value: null }"
            textField="text"
            valueField="value"
            [data]="statuses"
            [style]="{ width: '200px' }"
            (valueChange)="statusChange($event)"
          ></kendo-dropdownlist>
        </div>
        <div class="d-flex flex-column">
          <label
            class="form-label small text-muted mb-1"
            for="msp_customers_filter_type"
          >
            Type
          </label>
          <kendo-dropdownlist
            id="msp_customers_filter_type"
            [defaultItem]="{ display_text: 'All', id: null }"
            textField="display_text"
            valueField="id"
            [data]="accountTypeItems()"
            [style]="{ width: '240px' }"
            (valueChange)="accountTypeChange($event)"
          ></kendo-dropdownlist>
        </div>
      </div>

      <app-datatable
        [data-href]="datatableUrl"
        [columns]="datatableColumns"
        [useOData]="true"
        [initialFilters]="initialFilters"
        [clickableRows]="true"
        (rowClick)="viewOrg($event)"
      ></app-datatable>
    </div>
    } @else {
    <!-- Empty State -->

    <div class="empty-state">
      <div class="empty-state-content">
        <i class="k-icon k-i-customers"></i>
        <h3>No customers found</h3>
        <button
          kendoButton
          themeColor="primary"
          [svgIcon]="plusIcon"
          (click)="onAddCustomer()"
        >
          Add A Customer
        </button>
      </div>
    </div>
    }
  </div>
</div>
